const Config = {
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_PLACE_KEY,
  GOOGLE_CAPTCHA_KEY: process.env.REACT_APP_GOOGLE_CAPTCHA_KEY,
  googleGeocodingAPI: `https://maps.googleapis.com/maps/api/geocode/json?`,
  removeEditAndDeleteFromCart: false,
  functionForCareer: [
    "BIOCHEMISTRY",
    "COORDINATION",
    "CUSTOMER RELATIONS",
    "FINANCE & ACCOUNTS",
    "HAEMATOLOGY & CLINICAL PATHOLOGY",
    "HEALTH CHECK UP",
    "IT",
    "MICROBIOLOGY",
    "OPERATIONS",
    "PURCHASE & STORE",
    "RECEPTION",
    "SALES & MARKETING",
  ],
};

export { Config };
